module.exports = __webpack_public_path__ + "img/IMG_9701_L_BlackMatted_MockedUp.28643eca.jpg";